
export function processShipInfo (ship) {
  ship.url = ship.url?.replace('http:', 'https:')

  const shipImage = ship.images && ship.images?.[0] ? {
    url: ship.images[0].image,
    type: ship.images[0].type || ship.images[0].image_type || 'unknown',
  } : {}

  const dates = ship.available_dates?.map(({ date }) => date)

  return {
    ...ship,
    shipImage,
    dates,
  }
}
